import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ContactPage() {
  useEffect(() => {
    const hamburger = document.querySelector('.hamburger');
    const sidebar = document.getElementById('sidebar');
    const closeSidebar = document.querySelector('.close-sidebar');
    if (hamburger && sidebar && closeSidebar) {
      hamburger.onclick = () => sidebar.classList.add('active');
      closeSidebar.onclick = () => sidebar.classList.remove('active');
    }
    return () => {
      if (hamburger) hamburger.onclick = null;
      if (closeSidebar) closeSidebar.onclick = null;
    };
  }, []);

  return (
    <main className="contact-us-page">
      <nav className="regular-navbar">
        <Link className="logo" to="/">
          <img src="/logo.jpg" alt="company logo" />
        </Link>
        <div className="hamburger">
          <img src="/static/media/hamburger-black.c116047ebd06e70caac47be95fd90698.svg" alt="menu" />
        </div>
        <div className="links">
          <div className="void"></div>
          <div className="cont">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/loans">Loans</Link></li>
              <li><Link to="/savings-investments">Savings & Investment</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
            <div className="btns"><button className="transparent"><Link to="/register">Register</Link></button><button className="blue"><Link to="/login">Sign In</Link></button></div>
          </div>
        </div>
      </nav>
      <div id="sidebar">
        <ul>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div></div>
            <div className="close-sidebar">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
            </div>
          </div>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About us</Link></li>
          <li><Link to="/loans">Loans</Link></li>
          <li><Link to="/savings-investments">Savings & Investment</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <div className="btnss" style={{ marginTop: 14 }}>
            <button className="transparent" style={{ marginRight: 5 }}><Link to="/register">Register</Link></button>
            <button className="blue"><Link to="/login">Sign In</Link></button>
          </div>
        </ul>
      </div>
      <header className="page-header">
        <div className="text-info">
          <h1>Contact Us</h1>
          <p>We're here to help you with any questions or concerns you may have about our products and services. Our customer service team is available to assist you in any way possible, and we strive to provide prompt and helpful service to all of our customers. Whether you have a question about your account, need help with an online transaction, or simply want to provide feedback, we're here to help.</p>
        </div>
        <div className="img"><img src="/static/media/contact-us-header.4786371db9c269a17187.webp" alt="Contact Us" /></div>
      </header>
      <section className="get-in-touch">
        <div className="title-info">
          <h3>Get in touch with us</h3>
          <p>Please fill out the contact form on this page with your name, email address, and a brief message describing your inquiry. Our customer service team will get back to you as soon as possible.</p>
        </div>
        <form className="contact-form">
          <div className="form-row">
            <div className="form-control"><label htmlFor="name">Name</label><input type="text" id="name" name="name" /></div>
            <div className="form-control"><label htmlFor="email">Email</label><input type="text" id="email" name="email" /></div>
          </div>
          <div className="form-control"><label htmlFor="message">Message</label><textarea name="message" id="message"></textarea></div>
          <div className="btn"><button className="blue">Submit Message</button></div>
        </form>
      </section>
      <article className="financial-freedom">
        <div className="text">
          <h2>Take a Step Towards Financial Freedom</h2>
          <p>Ready to start achieving your financial goals? Open an account today and discover the benefits of banking with us all from the comfort of your home.</p><button className="white"><Link to="/register">Open an account today</Link></button>
        </div>
        <div className="img"><img src="/static/media/financial-freedom.81826f816f2e9f3fe1c9.png" alt="" /></div>
      </article>
      <footer className="footer">
        <div className="grid">
          <div className="item logo-info">
            <div className="logo"></div>
            <p>At Safenet Banking, your financial security is our top priority. We are committed to providing you with a seamless and secure online banking experience.</p>
          </div>
          <div className="item list">
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/terms-&-conditions">Terms & conditions</Link></li>
              <li><Link to="/privacy-policies">Privacy policies</Link></li>
            </ul>
          </div>
          <div className="item list">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/security">Security</Link></li>
            </ul>
          </div>
          <div className="item list">
            <h3>Customer Support</h3>
            <ul>
              <li><Link to="/contact">Get help</Link></li>
              <li><Link to="/frequently-asked-questions">FAQs</Link></li>
              <li><a href="mailto:info@safenetbanking.com">Email us</a></li>
            </ul>
          </div>
          <div className="item socials">
            <h3>Follow us</h3>
            <ul>
              <li><a href="#"><i className="fa fa-facebook"></i></a></li>
              <li><a href="#"><i className="fa fa-twitter"></i></a></li>
              <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
              <li><a href="#"><i className="fa fa-instagram"></i></a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright 2022 Safenet Banking. Licensed by the Central Bank of United States.</p>
        </div>
      </footer>
    </main>
  );
}
